import React from 'react';

export const FacebookIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5764 22.187V12.8932H16.6953L17.1617 9.27139H13.5764V6.95961C13.5764 5.91119 13.8684 5.19535 15.3711 5.19535H17.2894V1.95073C16.3605 1.85409 15.4269 1.80806 14.493 1.81284C11.731 1.81284 9.82885 3.49598 9.82885 6.60067V9.27139H6.70996V12.8932H9.82885V22.187H13.5764Z"
        fill="white"
      />
    </svg>
  );
};
